/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';

/**
 * This is a directive that is applied to an html input element
 * Makes sure the string input is within a provided array of strings
 */
@Directive({
    selector: '[appInvalidSegment]',
    providers: [{ provide: NG_VALIDATORS, useExisting: InvalidSegmentValidatorDirective, multi: true }],
    standalone: false
})

export class InvalidSegmentValidatorDirective implements Validator {
  @Input('appInvalidSegment') segments = [];

  validate(control: AbstractControl): ValidationErrors | null {
    return this.segments ? invalidSegmentValidator(this.segments)(control) : null;
  }
}

/**
 * Makes sure the string input is within a provided array of strings
 * Converts all strings to lowercase, ignores case
 * @param segments a list of segments the input must be in
 * @return either the validation error or null
 */
export function invalidSegmentValidator(segments: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const segmentsLowerCase = segments.map((str) => str.toLowerCase());
    let inputValue: string = control.value;
    if (control.value !== null && control.value !== undefined) {
      inputValue = control.value.toString().toLowerCase();
    }
    const invalid = !segmentsLowerCase.includes(inputValue);
    return invalid ? {invalidSegment: {value: inputValue}} : null;
  };
}
